import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getFileUrl } from '../warehouse.utils';

const SIZE_CLASSES = {
  sm: 'h-8 w-8 rounded-md',
  md: 'h-10 w-10 rounded-lg',
  lg: 'h-14 w-14 rounded-lg',
} as const;

/** Photo of a product or a variant from the file system, an icon when there is none or it fails to load */
@Component({
  selector: 'app-warehouse-thumb',
  templateUrl: './warehouse-thumb.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'inline-flex shrink-0' },
})
export class WarehouseThumbComponent {
  @Input() set fileId(value: string | null | undefined) {
    this.url = getFileUrl(value);
    this.failed = false;
  }
  @Input() size: keyof typeof SIZE_CLASSES = 'md';

  protected url: string | null = null;
  protected failed = false;

  protected get boxClass(): string {
    return `${SIZE_CLASSES[this.size]} grid shrink-0 place-items-center overflow-hidden bg-slate-100 text-slate-400 ring-1 ring-slate-200`;
  }
}
